import { render, staticRenderFns } from "./ColumnLayoutText.vue?vue&type=template&id=4e0604e8&scoped=true"
import script from "./ColumnLayoutText.vue?vue&type=script&lang=js"
export * from "./ColumnLayoutText.vue?vue&type=script&lang=js"
import style0 from "./ColumnLayoutText.vue?vue&type=style&index=0&id=4e0604e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0604e8",
  null
  
)

export default component.exports